import React, { useState } from 'react'
import RegisteredMemberChart from './RegisteredMemberChart'
import MemberEducationChart from './MemberEducationChart'
import MemberDetailChart from './MemberDetailChart'
import MaterialStatusChart from './MaterialStatusChart'
import MedicationChart from './MedicationChart'
import { Link } from 'react-router-dom'

export const MemberDashboard = () => {
  const [material, setMaterial] = useState(true)
  const [medication, setMedication] = useState(true)

  return (
    <>
    <section className='Admindashboard__task__wrapper '>
      <div className='container'>
          <div className='grid grid-cols-1 md:grid-cols-2 md:gap-6 gap-4 md:mt-6 mt-4'>
          <MemberEducationChart/>
          <MaterialStatusChart/>
          </div>
          <RegisteredMemberChart/>
          <MedicationChart/>
          
      </div>
    </section>
  </>
  )
}
